// @flow
import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'
import TradeView from './TradeView'
import moment from 'moment'
import { getPortfolioSnapshot } from '../../actions/portfolios'
import { Card } from 'reactstrap'
import { StyledContent } from '../../styles/mixins'
import ComponentContainer from '../container-component'
import { CSVLink } from 'react-csv';
import {Button, Icon, Input, Modal, Table, Select, Drawer} from 'antd'
import { PortfoliosGridWrapper, StyledDiv } from './style'
import { TableInput, TableSearch} from "../table-earnings/style";


const transactionColumns = [
  { name: 'tradeDate', title: 'Date', dataIndex: 'tradeDate' },
  { name: 'quantity', title: 'Qty', dataIndex: 'quantity'},
  { name: 'expiration', title: 'Exp Date', dataIndex: 'expiration'},
  { name: 'strike', title: 'Strike', dataIndex: 'strike' },
  { name: 'price', title: 'Price', dataIndex: 'price' },
  { name: 'transactionGroup', title: 'Group', dataIndex: 'transactionGroup' }
]
const Option = Select.Option;

class PositionsView extends Component {

  state: State = {
    defaultColumnWidths: [
      { columnName: 'openDate', width: 112 },
      { columnName: 'closedDate', width: 112 },
      { columnName: 'name', width: 250,},
      { columnName: 'symbols', width: 130 },
      { columnName: 'strategy', width: 180 },
      { columnName: 'profit', width: 110 },
    ],
    rows: [],
    searchTradeName: "",
    filterTradeNameDropdownVisible: false,
    filterMode: this.props.defaultOpen ? 1 : (localStorage.getItem('positionFilter') && parseInt(localStorage.getItem('positionFilter'))) || 0
  }

  componentWillMount() {
      const {
          portfolios: {
              portfolioSnapshot,
              error
          },
      } = this.props
    
    if (portfolioSnapshot.length === 0 && !error) {
        this.props.getPortfoliosList(this.props.account)
    } else {
        let items = [...(portfolioSnapshot || [])]
        if (items.length > 1) {
            items = items.sort((a, b) => {
                return +moment(b.openDate) - +moment(a.openDate);
            });
        }
        this.setState({
            rows: items
        })
    }
  }

  componentWillReceiveProps(nextProps) {
    if ((nextProps.portfolios.portfolioSnapshot.length && !this.props.portfolios.portfolioSnapshot.length) ||
      (this.props.portfolios.portfolioSnapshot.length && !nextProps.portfolios.portfolioSnapshot.length)
    ) {
        let items = [...(nextProps.portfolios.portfolioSnapshot || [])]
        if (items.length > 1) {
            items = items.sort((a, b) => {
                return +moment(b.openDate) - +moment(a.openDate);
            });
        }
        this.setState({
            rows: items
        })
    }
    if (this.props.account !== nextProps.account) {
      this.props.getPortfoliosList(nextProps.account)
    }
  }

  getFilteredList(list: Object[]): Object[] {

    const { filterMode } = this.state
    
    let items = [...(list || [])];

    let result: Object[] = items.filter((item: Object): boolean | Object[] => {

      if (filterMode === 0) return true
      else if (filterMode === 1) return (item.openData !== '') && !item.closedDate
      else return (item.openData !== '') && item.closedDate
    }).map(x=>({...x }))
    
    if (this.state.searchTradeName) {
      result = result.filter(x => x.name && x.name.props && x.name.props.children && x.name.props.children.startsWith(this.state.searchTradeName))
    }
  
    if (this.state.searchSymbol) {
      result = result.filter(x => x.symbols && x.symbols.startsWith(this.state.searchSymbol))
    }
    
    return result
  }

    // --- Company Name ---
  onFilterChange = (e: Object) => {
      this.setState({ [e.target.name]: e.target.value })
  }

  onNew = () => {
    this.props.history.push('/trades/new');
  }
  
  onDrawerOpen = () => {
    this.setState({
      isDrawer: true,
    })
  }
  
  onDrawerClose = () => {
    this.setState({
      isDrawer: false,
    })
  }
  
  onFilter = (val) => {
    localStorage.setItem('positionFilter', val);
    this.setState({ filterMode: parseInt(val)});
  }

  render() {
    const GridDetailContainerBase = (row): StyledDiv => {
      const rows: Object[] = row.transactions.map((item: Object): Object => {
        return {
          ...item,
          tradeDate: moment(item.tradeDate).format('MM/DD/YYYY') ,
          expiration: moment(item.expiratio).format('MM/DD/YYYY')
        }
      })

      return (
        <StyledDiv>
          {/*<div>*/}
            {/*<h5>Transactions:</h5>*/}
          {/*</div>*/}
          {/*<div>*/}
            {/*<Table*/}
              {/*columns={transactionColumns}*/}
              {/*size={'small'}*/}
              {/*dataSource={rows}*/}
              {/*pagination={false}*/}
            {/*/>*/}
          {/*</div>*/}
          <TradeView tradeData={row} tradeId={row.tradeId} />
        </StyledDiv>
      )
    }

    const columns = [
          {
              title: 'Opened',
              name: 'openDate',
              dataIndex: 'openDate',
              sorter: (a, b) => +moment(a.openDate) - +moment(b.openDate),
              render: (text, record, index) => moment(record.openDate).format('YYYY-MM-DD'),
          },
          {
              name: 'closedDate',
              title: 'Closed',
              dataIndex: 'closedDate',
              sorter: (a, b) => +moment(a.closedDate || '01-01-1968') - +moment(b.closedDate || '01-01-1968'),
              render: (text, record, index) =>  record.closedDate ?  moment(record.closedDate).format('YYYY-MM-DD') : '',
          },
          {
              title: 'Trade Name',
              name: 'name',
              dataIndex: 'name',
              width: '30%',
              sorter: (a, b) => {
                return (a.name && a.name.props && a.name.props.children || '') < (b.name && b.name.props && b.name.props.children || '') ? -1 : 1;
              },
              render: (text, record, index) => (<React.Fragment>
                <Link to={`/trade/${record.tradeID}/2`}><Icon type="line-chart" style={{color: '#17abe6', fontSize: 17, marginRight: 7}} />
                </Link>
                <Link to={`/trades/${record.tradeID}`}>{record.name}</Link></React.Fragment>),
              filterDropdown: (
                  <TableSearch>
                      <Input
                          placeholder='Search Trade'
                          name="searchTradeName"
                          value={this.state.searchTradeName}
                          onChange={this.onFilterChange}
                          // onPressEnter={this.onTradeNameSearch}
                          style={TableInput}
                      />
                      {/*<Button type='primary' onClick={this.onTradeNameSearch}>Search</Button>*/}
                  </TableSearch>
              ),
              filterIcon: <Icon type='search'/>,
          },
          {
              title: 'Symbols',
              name: 'symbols',
              dataIndex: 'symbols',
              width: '150px',
              sorter: (a, b) => {
                return a.symbols < b.symbols ? -1 : 1;
              },
              filterDropdown: (
                <TableSearch>
                  <Input
                    placeholder='Search Symbol'
                    name="searchSymbol"
                    value={this.state.searchSymbol}
                    onChange={this.onFilterChange}
                    style={TableInput}
                  />
                </TableSearch>
              ),
              filterIcon: <Icon type='search'/>,
          },
          {
              title: 'Strategy',
              name: 'strategy',
              dataIndex: 'strategy',
              sorter: (a, b) => {
                return a.strategy < b.strategy ? -1 : 1;
              }
          },
          {
              title: 'P/L',
              name: 'profit',
              dataIndex: 'profit',
              sorter: (a, b ) => a.profit - b.profit,
              render: (text) => `$${text}`
          }
      ]
    
    if (this.props.hasWriteAccess) {
      columns.push({
        title: 'Actions',
        dataIndex: '',
        render: () => {
          return (
            <Select value={''}>
              <Option value="">Select</Option>
              <Option value="split">Split</Option>
              <Option value="combine">Combine</Option>
              <Option value="delete">Delete</Option>
            </Select>
          )
        }
      });
    }
    

    const getCSVExportData = (data = []) => {
      return data.map(objData => {
         return {
           symbols: objData.symbols,
           name: objData.name && objData.name.props && objData.name.props.children,
           strategy: objData.strategy,
           profit: objData.profit,
           openDate: objData.openDate,
           closedDate: objData.closedDate,
         }
      })
    }

    
    const {
      portfolios: { 
        isFetching,
        error
      },
      getPortfoliosList,
      account
    } = this.props
    const { filterMode  } = this.state
    const rows = this.getFilteredList(this.state.rows);

    return (
      <section>
        { (isFetching || !!error) ?
          (
            <StyledContent>
              <ComponentContainer
                title={error || 'Loading Positions'}
                loading={isFetching}
                empty={!!error}
                resetData={() => getPortfoliosList(account)}>
                <p>Positions</p>
              </ComponentContainer>
            </StyledContent>
          ) :
          (
            <StyledContent>
              <Card>
                <div className="pt-2 pb-2 pl-2" style={{textAlign: 'right', paddingRight: 50}}>
                  {
                    this.props.hasWriteAccess && <Button icon="plus" style={{float: 'left', marginLeft: 10}} onClick={this.onNew}>New</Button>
                  }
                  <CSVLink data={getCSVExportData(rows)}>
                    <Icon type="download" style={{ marginRight: 10, fontSize: 22, cursor: 'pointer' }} />
                  </CSVLink>
                  <Select style={{width: 100}} value={filterMode} onChange={this.onFilter}>
                    <Option value={1}>Open</Option>
                    <Option value={2}>Closed</Option>
                    <Option value={0}>All</Option>
                  </Select>
                  <Icon onClick={this.onDrawerOpen} style={{position: 'absolute', right: 15, fontSize: 15, cursor: 'pointer'}} type="setting"/>
                </div>
                <PortfoliosGridWrapper>
                  <Table
                    columns={columns}
                    size={'small'}
                    dataSource={rows}
                    expandedRowRender={record => GridDetailContainerBase(record)}
                    pagination={false} />
                </PortfoliosGridWrapper>
              </Card>
              <Modal
                title="Choose Option"
                visible={this.state.onModalOpen}
                onCancel={() => this.setState({onModalOpen: false})}
                footer={null}
              >
                <Button icon="edit" onClick={() => this.props.history.push('/own-positions')}>Manual Enter</Button>
                <Button icon="table" style={{marginLeft: 10}}>Option Chain</Button>
                <Button icon="copy" style={{marginLeft: 10}}>Paste</Button>
                <p style={{marginTop: 10}}>If you would like to import your trades from your broker click here and follow the instructions on the screen.
                  here will link to the new import screen that we will be creating.</p>
              </Modal>
            </StyledContent>
          )
        }
        <Drawer
          title="Basic Drawer"
          placement="right"
          closable={true}
          onClose={this.onDrawerClose}
          visible={this.state.isDrawer}
        >
          <p>Some contents...</p>
          <p>Some contents...</p>
          <p>Some contents...</p>
        </Drawer>
      </section>
    )
  }
}

const mapStateToProps = state => ({
  portfolios: state.portfolios,
  account: state.account.selectedAccount,
  hasWriteAccess: state.account.hasWriteAccess,
})

const mapDispatchToProps = dispatch => ({
  getPortfoliosList(account) {
    getPortfolioSnapshot(dispatch, account)
  }
})

export default connect(mapStateToProps, mapDispatchToProps)(PositionsView)


// WEBPACK FOOTER //
// ./src/components/view-positions/index.js